<template>
  <div>
    <div>
      <v-app-bar class="menu-app-bar" absolute>
        <div class="menu-app-bar-content">        
          <v-btn 
            v-if="!drawerIsOpen"
            variant="text"
            class="menu-btn ml-0 pt-0" 
            @click="drawerIsOpen = !drawerIsOpen"
            >
            <v-icon>mdi-menu</v-icon>{{ t('navDrawer.menu') }}
          </v-btn>        
          <v-btn 
            v-else 
            variant="text"
            class="menu-btn ml-0 pt-0" 
            @click="drawerIsOpen = !drawerIsOpen"
          >
            <v-icon>mdi-close</v-icon>{{ t('navDrawer.close') }}
          </v-btn>       
          <v-spacer />
          <v-img
            :src="busImage"            
            :alt="t('app.busImageAlt')"
            max-height="34"
            contain
          />
          <v-img
            :src="TfWLogo"
            :alt="t('app.logoAlt')"
            max-height="34"
            contain
          />
          <v-spacer />
          <RefreshButtonVue class="refresh-btn ma-0" />         
        </div>
      </v-app-bar>
      <div class="refresh-label-container">
        <RefreshLabel class="refresh-label" />
      </div>
    </div>
    <v-navigation-drawer 
      v-if="drawerIsOpen"
      class="nav-drawer" 
      v-model="drawerIsOpen" 
      touchless 
      width="100%"      
      >
      <v-container class="link-container">
        <v-row class="">
          <v-col v-if="playlist.id" cols="12" class="v-col">
            <v-btn
              variant="plain"
              class="home-btn text-nav-btn-text ma-2 mb-5"
              @click="showSplashScreen()"
            >
              <v-icon>mdi-home</v-icon>&nbsp;&nbsp;{{ t('navDrawer.home') }}
            </v-btn>
          </v-col>
          <v-col cols="12" class="v-col">
            <v-btn
              variant="plain"
              class="home-btn text-nav-btn-text ma-2 mb-5"
              @click="showTimetable()"
            >
              <v-icon>mdi-timetable</v-icon>&nbsp;&nbsp;{{ t('navDrawer.timetable') }}
            </v-btn></v-col
          >
          <v-col cols="12" class="v-col">
            <v-btn
              variant="plain"
              class="home-btn text-nav-btn-text ma-2 mb-5"
              @click="showMessages()"
            >
              <v-badge
                v-if="hasMultipleMessages"
                color="error"
                :content="getmessagesForQRCode.length"
              >
                <v-icon>mdi-email</v-icon>
              </v-badge>
              <v-icon v-else>mdi-email</v-icon>&nbsp;&nbsp;{{ t('navDrawer.informationMessages') }}
            </v-btn></v-col
          >
          <v-col cols="12" class="v-col">
            <v-btn
              variant="plain"
              class="home-btn text-nav-btn-text ma-2 mb-5"
              @click="showLinks()"
            >
              <v-icon>mdi-web</v-icon>&nbsp;&nbsp;{{ t('navDrawer.links') }}
            </v-btn></v-col
          >
          <v-col cols="12" class="v-col">
            <v-btn
              variant="plain"
              class="home-btn text-nav-btn-text ma-2 mb-5"
              @click="showCookieSettings()"
            >
              <v-icon>mdi-cookie</v-icon>&nbsp;&nbsp;{{ t('navDrawer.cookies') }}
            </v-btn></v-col
          >
        </v-row>
      </v-container>

      <template v-slot:append>
        <div class="margin-bottom">
          <v-card class="nav-draw-footer mb-5" variant="text">
            <v-card-title
              ><v-icon left>mdi-wheelchair</v-icon>
              &nbsp;{{ t('accessibilitySettings.title') }}
            </v-card-title>
            <contrast-switch />
            <speech-switch />
            <language-switch />
          </v-card>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import ContrastSwitch from "./ContrastSwitch.vue";
import LanguageSwitch from "./LanguageSwitch.vue";
import SpeechSwitch from "./SpeechSwitch.vue";
import RefreshButtonVue from "./RefreshButton.vue";
import RefreshLabel from "./RefreshLabel.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { useI18n } from 'vue-i18n'

export default {
  components: {
    ContrastSwitch,
    LanguageSwitch,
    RefreshButtonVue,
    RefreshLabel,
    SpeechSwitch,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data: () => ({
    audioSwitchValue: true,
    drawerIsOpen: false,
    busImage: require("@/assets/bus.svg"),
    TfWLogo: require("@/assets/TfWLogo.svg"),
  }),
  methods: {
    ...mapActions(["updateCurrentPage"]),
    showCookieSettings() {
      this.$emit("showCookieSettings");
    },
    showSplashScreen() {
      this.updateCurrentPage("playlist-screen");
      this.drawerIsOpen = false;
    },
    showMessages() {
      this.updateCurrentPage("messages");
      this.drawerIsOpen = false;
    },
    showTimetable() {
      this.updateCurrentPage("timetable");
      this.drawerIsOpen = false;
    },
    showLinks() {
      this.updateCurrentPage("links");
      this.drawerIsOpen = false;
    },
  },
  computed: {
    ...mapState(["currentPage", "splashEnabled", "playlist", "selectedLanguage"]),
    ...mapGetters(["getmessagesForQRCode"]),
    hasMultipleMessages() {
      return this.getmessagesForQRCode.length > 1;
    },
  },
};
</script>

<style>
.refresh-btn {
  height:100%;
  padding: 0;
  margin-right: -5px;
}
.margin-bottom {
  margin-bottom: 14vh;
}
.link-container .v-col {
  padding: 0px;
  margin: 0px;
}
.menu-btn {
  z-index: 1009 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent;
  width: 75px;
  margin-left: 10px !important;
  padding-left: 20px !important;
  display: flex !important;
  justify-content: flex-start !important;
}
/* iOS keeps :hover after a tap, leaving Vuetify's grey overlay visible */
@media (hover: none) {
  .menu-btn .v-btn__overlay {
    opacity: 0 !important;
  }
}
.nav-drawer {
  top: 60px !important;
  height: 65vh !important;
  max-width: 400px;
  margin: 0 auto;
}
.home-btn {
  margin-left: 0px !important;
  margin-right: 100px;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  font-weight: bolder;
  font-size: 16px !important;
  float: left;
}
.menu-app-bar .v-toolbar__content {
  height: 74px !important;
  top:0 !important;
  justify-self: top;
  align-self: start;
  justify-items: top;
  align-items: start;
  color: black !important;
}
.menu-app-bar {
  z-index: 1008 !important ;
  position: fixed !important;
  top: 0vh !important;  
  background-color: rgb(var(--v-theme-surface-light)) !important;
  color: black;
  height: 50px !important;  
}
.menu-app-bar-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width:90%;
  margin: 0 auto;
  margin-top: 14px !important;
  height: 44px;
  background-color: white;
  border-radius: 22px;
  border-top:5px;

}
.refresh-label-container {
  position: fixed !important;
  top: 56px !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1008 !important;
  width: 100%;
}
.refresh-label {
  width: 100%;
  background-color: None;
  display: flex;
  align-items: bottom;
  justify-content: end;
  cursor: pointer;  
  padding-top:0;
  padding-bottom:0;
  padding-right:5%;
  font-size: small;
  margin-top: 2px !important;  
  color: rgb(var(--v-theme-nav-btn-text)) !important;
}


.nav-draw-footer {
  
  background: secondary !important;
}
</style>